var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-path-inner",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0009 15.7432C8.75964 14.9331 9.73481 13.6108 9.42556 12.4515C9.21307 11.6585 8.24549 10.3874 4.15315 10.7535C3.80596 10.7839 3.54983 11.0912 3.58209 11.4384C3.61244 11.7856 3.916 12.0398 4.26699 12.0116C7.14888 11.7515 8.10319 12.3984 8.20564 12.776C8.32327 13.2237 7.70857 14.0281 6.47157 14.5973C5.63679 14.9806 5.18715 15.5042 5.13023 16.1512C5.03726 17.261 6.24011 18.1224 6.37861 18.2174C6.48675 18.2912 6.61197 18.3275 6.73529 18.3275C6.93639 18.3275 7.13371 18.2324 7.25703 18.0541C7.45434 17.7657 7.38035 17.373 7.09386 17.1757C6.82825 16.9935 6.36533 16.5306 6.38999 16.2574C6.40137 16.1058 6.63094 15.914 7.0009 15.7432ZM21.38 8.10309L19.5928 6.31779C19.3462 6.07115 18.9478 6.07115 18.7011 6.31779L9.77086 15.2462C9.70256 15.3164 9.64943 15.3998 9.61908 15.4928L8.72548 18.1736C8.64959 18.3994 8.70841 18.6498 8.87916 18.8187C8.99868 18.9401 9.15995 19.0046 9.32501 19.0046C9.39141 19.0046 9.45971 18.9932 9.52422 18.9704L12.2031 18.0787C12.2961 18.0484 12.3815 17.9955 12.4498 17.927L21.38 8.99669C21.4977 8.87906 21.5641 8.71779 21.5641 8.55084C21.5641 8.38198 21.4977 8.22261 21.38 8.10309ZM11.6624 16.9271L10.323 17.3749L10.7688 16.0356L15.5745 11.2297L16.4681 12.1216L11.6624 16.9271ZM17.3617 11.2297L16.4681 10.3361L19.147 7.65724L20.0406 8.55084L17.3617 11.2297Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.d8f71103eb8f1cbe3cbc1fe7e353d3f9.svg";
export { ForwardRef as ReactComponent };